<template>

  <section class="" style="background: #F6F6F6;color:black">
    <div class="container ">
      <div class="section-title page-title">

        <div class="row m-0">
          <div class="col-12">
            <div class="content text-center">

              <ContentsCapitalLabel
                isSecondaryColor="true"
                label="STOCKING, MULTIPLE WAREHOUSE LOCATION, FLEXIBLE DELIVERY"
              />
      
              <h2 class="title h2-caslon text-black text-center f-44 fw-600">Logistics Supports</h2>

            </div>
          </div>
        </div>
        
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">

        <div class="content">
          <ContentsTextWithImage
            title="Logistics Support"
            image-url="/pages/products/services/s-services.jpg"
            :contents="[
              'We help keeping inventory to support your suddenly need and reduce your logistics investment',
            ]"
            is-reverse="true"
            is-white-content="true"
            left-width="46.267%"
            right-width="53.733%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content pb-0">

        <ContentsTextWithImage
          title="Just-in-Time (JIT) Inventory managementI"
          image-url="/pages/products/services/lo.jpg"
          :contents="[
            'Our logistics service is the heart of our business. We help customer to reduce inventory cost, increase turnover, reduce inventory space hence storage cost, and reduce raw material lead time. By our JIT service your company largely improve return on investment and improve your cash flow because you don’t need to hold high inventory level as well as reducing investment in logistics facility. You just order quantity you need at time from our flexible MDQ.',
          ]"
          is-reverse="true"
          left-width="52.763%"
          right-width="46.933%"
        />

      </div>
    </div>
  </section>

  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content p-0">

        <ContentsTextWithImage
          title="Stockist & warehousing"
          image-url="/pages/products/services/stockist.jpg"
          :contents="[
            'External changes in environment are difficult to predict and out of control. In plastic resins as well. There’s opportunities of material shortage or price fluctuations. Having someone to foresee the future and keep stock at the right time is one of the solutions to overcome this issue. At Nagase, we support your JIT activity by having raw materials available for your order. Especially importing raw materials from overseas could be longer than usual.',
          ]"
          left-width="55.92%"
          right-width="43.776%"
        />

      </div>
    </div>
  </section>

  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content pb-0">

        <ContentsTextWithImage
          title="Transportation"
          image-url="/pages/products/services/transport.jpg"
          :contents="[
            'Our logistics service is the heart of our business. We help customer to reduce inventory cost, increase turnover, reduce inventory space hence storage cost, and reduce raw material lead time. By our JIT service your company largely improve return on investment and improve your cash flow because you don’t need to hold high inventory level as well as reducing investment in logistics facility. You just order quantity you need at time from our flexible MDQ.',
          ]"
          is-reverse="true"
          left-width="54.505%"
          right-width="45.191%"
        />

      </div>
    </div>
  </section>

  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content pb-0" style="padding-top: 60px">

        <ContentsTextWithImage
          title="Custom clearance"
          image-url="/pages/products/services/custom.jpg"
          :contents="[
            'If your main activity is to produce high quality products and sometime dealing with custom officer is daunting task. Why don’t let our expert to handle your import shipment? At Nagase we have many experience staffs to dealing with shipping agent, customs, BOI officer to expedite import procedure as well as consulting when there’s demanding request from officer',
          ]"
          left-width="54.632%"
          right-width="45.064%"
        />

      </div>
    </div>
  </section>

  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content" style="padding-bottom: 40px">

        <ContentsTextWithImage
          title="Material management Turnkey project"
          image-url="/pages/products/services/s-services.jpg"
          :contents="[
            'We help brand owner and OEM service to manage plastic resins from material sourcing, buying, import, inventory management, to delivery to nominated fabricators. You can focus on your core activity and leave material supply to us. Our team will plan and exchange information together with your planning team for demand trend and material supply trend in order to prevent material shortage and smoothen your operation with most efficient cost.',
          ]"
          is-reverse="true"
          left-width="52.762%"
          right-width="46.932%"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'Logistics Supports - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.page-title {
  padding: 50px 0 0;
}
.page-title .title {
  margin: 40px 0 30px;
}

.page-title .capital-label {
  font-family: 'Roboto', sans-serif;
}
</style>